import type { GenericUserFilter, UserFilter } from 'plp/types/Filters'

import { ALL } from './constants'

function uniqueSelection(filter: UserFilter, value: string) {
	const currentFilter = filter
	if (value === ALL) {
		currentFilter.selection = [ALL]
		return currentFilter
	}
	if (value !== ALL && currentFilter.selection.includes(value)) {
		currentFilter.selection = [ALL]
		return currentFilter
	}
	if (value !== ALL && !currentFilter.selection.includes(value)) {
		currentFilter.selection = [value]
		return currentFilter
	}
	return filter
}

function updatedSelection(
	isUniqueOption: boolean,
	filter: UserFilter,
	value: string,
	toggle = true
) {
	const currentFilter = filter
	if (isUniqueOption) {
		return uniqueSelection(currentFilter, value)
	} else if (currentFilter.selection.includes(value)) {
		currentFilter.selection = currentFilter.selection.filter(
			(item) => item !== value
		)
		return currentFilter
	} else {
		if (toggle) {
			currentFilter.selection.push(value)
		}
		return currentFilter
	}
}

export function updateFilter(
	type: string,
	id: string,
	value: string,
	oldState: UserFilter[],
	toggle = true
) {
	if (oldState !== undefined) {
		return oldState.map((filter) => {
			const idFilter = (filter as GenericUserFilter).id
			if (!(filter.type === type && (id === '' || idFilter === id))) {
				return filter
			}
			const isUniqueOption = !filter.multipleChoice
			return updatedSelection(isUniqueOption, filter, value, toggle)
		})
	}
	return oldState
}
